enum RechargeAPIVersion {
  v1 = "2021-01",
  v2 = "2021-11"
}

export { RechargeAPIVersion };
